import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@lciapps/auth';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-sso-saml',
  template: `
    <p></p>
  `
})
export class SsoSamlComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.authService
      .completeAuthorization()
      .then(user => {
        this.router.navigate(['/']);
      })
      .catch(err => {
        console.log(err);

        this.authService.manager.clearStaleState().then(() => {
          this.authService.loggedIn$.subscribe(loggedIn => {
            if (loggedIn) {
              this.router.navigate(['/']);
            } else {
              this.authService.login().then(t => {
                const email = this.route.snapshot.queryParams.email;
                const samlToken = this.route.snapshot.queryParams.samlToken;

                let state = '';
                let nonce = '';

                for (let i = 0; i < window.localStorage.length; i++) {
                  const key = window.localStorage.key(i);
                  if (key.slice(0, 5) === 'oidc.') {
                    const token = JSON.parse(window.localStorage.getItem(key));
                    state = token.id;
                    nonce = token.nonce;
                    break;
                  }
                }

                window.location.href = `${
                  environment.auth_authority
                  }saml/mylion?email=${email}&samlToken=${samlToken}&state=${state}&nonce=${nonce}`;
              });
            }
          });
        });
      });
  }
}
